import type { FC } from 'react';
import React from 'react';

import type { TPageZoomer } from './models';

export const PageZoomer: FC<React.PropsWithChildren<TPageZoomer>> = ({ children }) => (
    <div
        style={{
            minWidth: '1200px',
        }}
    >
        {children}
    </div>
);
